import React from "react";
import MarginDashboard from "./components/MarginDashboard";
import ManageSlots from "./components/ManageSlots";
import CreateAccount from "../navigo-module/components/CreateAppointment";
import DocumentUpload from "../navigo-module/components/DocumentUpload";

class MarginModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 0,
      props: null,
      dashboardKey: 0,
      dashboardKeyReload: 0,
      dashboardFilter: null,
    };
  }

  setView = (v, p, filter) => {
    this.setState((prev) => ({
      view: v,
      props: p,
      dashboardFilter: filter ?? prev.dashboardFilter,
      dashboardKey: v === 0 ? prev.dashboardKey + 1 : prev.dashboardKey,
    }));
  };

  resetDashboard = () => {
    this.setState((prev) => ({ dashboardKey: prev.dashboardKey + 1 }));
  };

  render() {
    const { view, props, dashboardKey, dashboardFilter } = this.state;

    return (
      <>
        {/* DASHBOARD */}
        <div style={{ display: view === 0 ? "block" : "none" }}>
          <MarginDashboard
            key={dashboardKey}
            setView={this.setView}
            data={props}
            history={this.props.history}
            dashboardFilter={dashboardFilter}
          />
        </div>

        {/* MANAGE SLOTS */}
        {view === 1 && (
          <ManageSlots
            setView={this.setView}
            data={props}
            resetDashboard={this.resetDashboard}
          />
        )}
        {/* DocumentUpload should be at view 2, so that the payment flow - for
         redirection on apt detail screen - sets the view to 2. */}
        {view === 2 && (
          <DocumentUpload
            setView={this.setView}
            data={props}
            resetDashboardReload={() => {}}
          />
        )}
        {view === 3 && (
          <CreateAccount
            setView={this.setView}
            data={props}
            resetDashboard={() => {}}
          />
        )}
      </>
    );
  }
}

export default MarginModule;
